import { ColumnsPreferenceRecognizedLists } from '../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { FilterGroupByEnum } from '../../filter/reportFilter.types';

export const ORDERS_INCOME_REPORT_COLUMNS_KEY = 'oi';

export const ORDER_ITEMS_INCOME_REPORT_COLUMNS_KEY = 'oii';

export const ordersIncomeReportKeysToIgnore = [
  ORDERS_INCOME_REPORT_COLUMNS_KEY,
  ORDER_ITEMS_INCOME_REPORT_COLUMNS_KEY,
];

export const ORDERS_INCOME_REPORT_COLUMNS_KEYS_BY_GROUP_BY = {
  [FilterGroupByEnum.ORDER]: ORDERS_INCOME_REPORT_COLUMNS_KEY,
  [FilterGroupByEnum.ORDER_ITEM]: ORDER_ITEMS_INCOME_REPORT_COLUMNS_KEY,
};

export const ORDERS_INCOME_REPORT_LIST_BY_GROUP_BY = {
  [FilterGroupByEnum.ORDER]: ColumnsPreferenceRecognizedLists.REPORT_ORDERS_INCOME,
  [FilterGroupByEnum.ORDER_ITEM]: ColumnsPreferenceRecognizedLists.REPORT_ORDER_ITEMS_INCOME,
};
